import { DataFormModel, FormItemConfig } from "./dataFormModel";

export const cloneColumnsConfig = (templateColumns: FormItemConfig[]): FormItemConfig[] => {
  const columns = templateColumns.map((x) => {
    return { ...x };
  });
  return columns;
};

export const cloneFormModel = (templateModel: DataFormModel): DataFormModel => {
  const ret = {
    panels: templateModel.panels.map((x) => {
      const p = { ...x };
      p.columns = cloneColumnsConfig(p.columns);
      return p;
    }),
  } as DataFormModel;
  return ret;
};
